<template>
  <a :href="replaceHostName(notification.action_url)" class="list-group-item list-group-item-action px-2 rounded-0 border-left border-right">
    <div class="media px-2">
      <span class="align-self-center mr-3">
        <i v-bind:class="notification.icon"></i>
      </span>
      <div class="media-body text-truncate">
        <span class="m-0 text-truncate">
          <h5 class="font-weight-bold text-primary m-0 text-truncate">
            {{ notification.title }}
          </h5>
          {{ notification.body }}
        </span>
        <p class="m-0">
          <small class="timestamp">
            <timeago :datetime="notification.created" :auto-update="30" locale="es"></timeago>
          </small>
        </p>
      </div>
      <a href="#" @click.prevent="markAsRead" class="float-right" v-tooltip="'Marcar como leído'">
        <i class="fa fa-times text-muted" aria-hidden="true"></i>
      </a>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    notification: {
      type: Object,
      required: true
    }
  },

  methods: {
    markAsRead () {
      this.$emit('read')
    },

    replaceHostName(val){
      if (!val) {
        return window.location.href
      }
      return val
      /*var url = new URL(val); //No funciona en IE y Safarí.
      url.hostname = window.location.hostname;
      return url.href;*/
    }
  }
}
</script>
